<template>
  <h1>home</h1>
</template>

<script setup lang="ts">

</script>

